import { reducers } from 'redux/core'
import request from 'sb-request'


const getGQLParams = ({ slug, gender }) => `(slug: "${slug}", gender: "${gender}")`

/**
 * Fetches collection data
 *
 * @param {Object} params
 * @param {String} params.slug
 * @param {('male'|'female')} params.gender
 *
 * @returns {Promise} request
 */
const fetch = ({ slug, gender }) => {
  reducers.view.collectionPage.setFetched(false)

  return request.post('graphql?name=collection', {
    body: {
      query: `{
      collection${getGQLParams({ slug, gender })} {
        id
        url
        title
        status
        collectionType
        products {
          id
          url
          img
          sex
          type
          name
          brand
          rating
          labels
          category
          upchargePrice
        }
        imgMobile
        imgDesktop
        appearance
        description
      }
    }`,
    },
    modifyResult: (data) => (data && data.collection || {}),
  })
    .then(
      (collection) => {
        reducers.view.collectionPage.setCollection(collection)

        return collection
      })
}


export default {
  fetch,
}
